export const DATE_FORMAT = {
    expirationDateFormat: 'MM/yy',
    displayedDateFormat: 'dd MMMM',
    displayedDateYearFormat: 'dd MMMM yyyy',
    displayedDateYearFormatWithNameOfDay: 'EE dd MMMM yyyy',
    displayedDateYearFormatWithNameOfMonth: 'dd MMM. yyyy',
    displayedDateYearFormatWithTime: 'dd.MM.yyyy, HH:mm',
    salesManagoEventDateFormat: 'dd-MM-yyyy',
};
